import authAction from 'redux/auth/action';
import request from 'helpers/request';
import Provider from './provider';
import profileAction from 'redux/profile/action';
import { login, webhookURL_profile } from 'constants/url';
import { error } from 'utils/notification';
import getCode from 'utils/getRoleCode';
import { allowedRoles } from 'constants/globalVariable';

export default {
  login: async (params, getRegencyById) => {
    return await request
      .post(login, { email: params?.email, password: params?.password })
      .then(async (res) => {
        const { data = {} } = res || {};

        await authAction.setAuth(data);

        const dataProfile = await Provider.singleWebHook(webhookURL_profile);

        // Validasi role akses
        if (!allowedRoles?.includes(dataProfile?.data?.role?.role_code)) {
          return Promise.reject({
            status: 'denied',
            message: 'Mohon maaf anda tidak memiliki akses',
          });
        }

        let dataRegency;
        const userRoleCode = dataProfile?.data?.role?.role_code;
        const isSupervisor = userRoleCode === getCode('Supervisor');

        // Jika role adalah supervisor, skip hit API regency
        if (!isSupervisor && dataProfile?.data?.school?.regency_id) {
          dataRegency = await getRegencyById({
            variables: {
              id: dataProfile?.data?.school?.regency_id,
            },
            onError: (err) => {
              return error({
                description: err.message,
                placement: 'bottomRight',
              });
            },
          });
        }

        profileAction.setProfile({
          ...dataProfile?.data,
          school: {
            ...dataProfile?.data?.school,
            // Hanya set regency_name jika bukan supervisor dan dataRegency tersedia
            ...(!isSupervisor &&
              dataRegency && {
                regency_name: dataRegency?.regencyById?.name,
              }),
          },
        });
      })
      .catch((err) => {
        authAction.clearAuth();
        profileAction.clearProfile();

        return Promise.reject({
          status: err?.status,
          message: err?.response?.data?.error?.message || err?.message,
        });
      });
  },

  refreshToken: async (refreshToken) =>
    await request.patch('services/auth', { refreshToken }).then((res) => {
      authAction.setToken(res.data.attributes);
    }),
  resend: async (params) => {
    const param = {
      email: params,
    };
    const { data } = await request.post('services/emailverification', param);
    return data;
  },
  logout: async () => await authAction.clearAuth(),
};
